import React from 'react';
import Helmet from 'react-helmet';
import Layout from './_faqsLayout';

export default (props) => {
  return (
    <React.Fragment>
      <Helmet>
        <title> 
          Skákgreind | Algengar spurningar 
        </title>
      </Helmet>
      <Layout {...props} />
    </React.Fragment>
  )
}

export const query = graphql`
  query faqsIsQuery {
        html: markdownRemark(id: {regex: "/is\/faqs/"}) {
        html
      }
      }
`


// WEBPACK FOOTER //
// ./src/pages/about/faqs/index.is.js